import { VIEW, E_RISK_TYPE } from 'interfaces';
import { inject } from 'mobx-react';
import React from 'react';
import { IMobxRootState } from 'RootStore';
import GQMapProvider from 'components/GQMap/GQMapProvider';
import useInitCountryDim from 'hooks/useInitCountryDim';
import { MultilateralRiskPage } from 'components/Pickers/MultilateralRiskPicker';

type ContingentMapPageProps = {
    countries?: number[];
};

type ContingentMapProps = {
    showChart?: boolean;
    countries?: number[];
};

export const ContingentMapPage = inject(({ countryStore }: IMobxRootState) => {
    return {
        countries: countryStore.currentCountryList,
    };
})(({ countries }: ContingentMapPageProps) => {
    return (
        <MultilateralRiskPage>
            <ContingentMap countries={countries} />
        </MultilateralRiskPage>
    );
});

export const ContingentMap = React.memo((props: ContingentMapProps) => {
    const ready = useInitCountryDim({
        riskType: E_RISK_TYPE.CONTINGENT,
        multiCountry: true,
        multiRisk: false,
    });

    if (!ready) {
        return null;
    }
    return ready && <GQMapProvider view={VIEW.CONTINGENT} />;
});
